import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
  size?: 'lg' | 'xl';
  className?: string;
  trackAddToCart?: boolean;
}
export function CTAButton({
  text,
  onClick,
  href = 'https://iaexpres2026.com/cart/46495237374142:1',
  size = 'xl',
  className = '',
  trackAddToCart = false
}: CTAButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-semibold text-white rounded-full overflow-hidden group transition-all duration-300 shadow-[0_8px_20px_rgba(212,165,116,0.3)] hover:shadow-[0_12px_25px_rgba(212,165,116,0.5)]';
  const sizeClasses = size === 'xl' ? 'px-8 py-5 text-lg md:text-xl w-full md:w-auto' : 'px-6 py-4 text-base md:text-lg w-full md:w-auto';
  const ButtonContent = () => <>
      <span className="absolute inset-0 w-full h-full gradient-gold group-hover:scale-105 transition-transform duration-500 ease-out" data-id="element-45"></span>
      <span className="absolute inset-0 w-full h-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-46"></span>
      <span className="relative flex items-center gap-2" data-id="element-47">
        {text}
        <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-48" />
      </span>
    </>;
  const motionProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    animate: {
      boxShadow: ['0px 8px 20px rgba(212,165,116,0.3)', '0px 8px 30px rgba(212,165,116,0.5)', '0px 8px 20px rgba(212,165,116,0.3)']
    },
    transition: {
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }
  };
  const handleClick = (e?: React.MouseEvent) => {
    if (trackAddToCart && typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'IA Express 2026',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    if (onClick) onClick();
  };
  if (href) {
    return <motion.a href={href} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${className}`} {...motionProps} data-id="element-49">
        <ButtonContent data-id="element-50" />
      </motion.a>;
  }
  return <motion.button onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${className}`} {...motionProps} data-id="element-51">
      <ButtonContent data-id="element-52" />
    </motion.button>;
}